<template>
    <div>

        <config-main-title>
            Histórico Legado
        </config-main-title>

        <div class="row mb-3 w3-animate-opacity">

            <div class="col col-12">

                <az-input 
                    placeholder="Paciente"
                    icon="fas fa-user"
                    type="autocomplete" 
                    optionsMode="aql"
                    service="pacientes.index"
                    optionsDisplay="search"
                    ref="info_paciente"
                    v-model="paciente" 
                    @input="selecionarPaciente()">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="paciente">
                            <button type="button" class="btn btn-outline-primary" @click="$root.perfil(paciente);">
                                <i class="fa fa-id-badge" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                </az-input>

            </div>

        </div>

        <div v-if="!paciente"> 

            <az-empty-state
                :msg="paciente ? 'Nenhum paciente identificado.' : 'Selecione o paciente.'" 
                :icon="paciente ? 'fas fa-clone' : 'fa fa-search'"
                v-if="!paciente" />

        </div>

        <div class="row mb-3" v-if="paciente">
            <div class="col col-12">
                <identificacao-paciente :pacientes="[paciente]" tipo="Paciente" />
                <button type="button" class="btn btn-primary" @click="incluir()">Incluir Manual</button>
            </div>
        </div>

        <template v-if="paciente && dados && dados.length">
            <div v-for="(legado, ilx) in dados" :key="ilx">
                <pep-view-card-legado :item="legado" :manual="true">
                    <div class="mt-3" v-if="!legado.st_id_externo && legado.st_origem == 'Manual'">
                        <button class="btn btn-sm btn-outline-primary" @click="editar(legado)">
                            Editar
                        </button>
                    </div>
                </pep-view-card-legado>
            </div>
        </template>

        <!-- Modal -->
        <div class="modal fade" id="legadoManualModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">Legado</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div class="form-row">
                                <div class="col col-12 col-md-3">
                                    <az-input 
                                        label="Data"
                                        type="datetime-local"
                                        required
                                        :validate="validate"
                                        v-model="edicao.dt_data" />
                                </div>

                                <div class="col col-12 col-md-9">
                                    <az-input 
                                        label="Profissional Executante"
                                        required
                                        :validate="validate"
                                        v-model="edicao.st_nome_medico" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input 
                                        label="Título"
                                        placeholder="Informar..."
                                        required
                                        :validate="validate"
                                        v-model="edicao.st_descricao" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input 
                                        label="Accession Number"
                                        placeholder="Opcional..."
                                        :validate="validate"
                                        v-model="edicao.st_an" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input 
                                        type="textarea"
                                        label="Conteúdo"
                                        placeholder="Informar..."
                                        :validate="validate"
                                        v-model="edicao.st_conteudo" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="prontuarioLegado" :id="edicao.id_prontuario_legado" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ edicao.id_prontuario_legado ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import IdentificacaoPaciente from '../shared/IdentificacaoPaciente.vue';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import PepViewCardLegado from '../../modulos/consultorio/PepViewCardLegado.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() { 
        return { 
            paciente: "",
            outro_paciente: "", 
            destino: "",
            dados: [],
            ativado: false, 
            edicao: null, 
            validate: false, 
        }
    },

    components: { 
        AzInput,
        AzEmptyState, 
        IdentificacaoPaciente, 
        ConfigMainTitle,
        AzSubmit, 
        PepViewCardLegado,
        AzAuditLogButton,
    },

    methods: { 
        editar (legado) { 
            this.edicao = _.cloneDeep(legado);
            this.validate = false; 

            $('#legadoManualModal').modal('show');
        }, 

        incluir () { 
            this.validate = false; 

            this.edicao = { 
                id_paciente: this.paciente.id_pessoa,
                dt_data: null, 
                st_descricao: "",
            };

            $('#legadoManualModal').modal('show');
        },

        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'pep_legado',
                func: 'atualizar',
                dados: this.edicao,
                modal: "legadoManualModal",
                toast: true,
                callback: () => { 
                    this.selecionarPaciente();
                },
            });

        },

        selecionarPaciente () { 
            this.dados = []; 

            if ( !this.paciente ) 
                return;

            this.destino = null;

            this.$util.load(this, { 
                service: 'pep',
                func: 'legado',
                parms: { 
                    id_paciente: this.paciente.id_pessoa ? this.paciente.id_pessoa : -1,
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        },

    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Configurações", path: "/cadastros" },
            { name: "Histórico Legado", path: "/config/historico-legado" }
        ]);
    }
}
</script>